export interface InvoiceStatusView {
  label: 'Draft' | 'Sent' | 'Awaiting verification' | 'Part paid' | 'Paid' | 'Void';
  cls: string;
}

const BADGE = {
  paid: 'bg-success/20 text-success',
  void: 'bg-danger/20 text-danger',
  awaiting: 'bg-warning/20 text-warning',
  part: 'bg-info/20 text-info',
  draft: 'bg-gray-100 text-gray-600 dark:bg-white/10 dark:text-gray-300',
  sent: 'bg-primary/10 text-primary',
} as const;

/**
 * One label for "where is this invoice", from the two fields that used to be read separately
 * (the invoice lifecycle `status` and the money-side `payment_status`). Order matters: a voided
 * invoice is void whatever was paid, and a fully paid one is paid whatever its lifecycle says.
 */
export function invoiceStatus(inv: { status: string; payment_status?: string | null }): InvoiceStatusView {
  if (inv.status === 'VOID') return { label: 'Void', cls: BADGE.void };
  if (inv.payment_status === 'PAID') return { label: 'Paid', cls: BADGE.paid };
  // Legacy rows can carry status PAID while payment_status says part paid: they still owe money.
  if (inv.status === 'PAID' && inv.payment_status !== 'PARTIALLY_PAID') return { label: 'Paid', cls: BADGE.paid };
  if (inv.status === 'PENDING_VERIFICATION') return { label: 'Awaiting verification', cls: BADGE.awaiting };
  if (inv.payment_status === 'PARTIALLY_PAID') return { label: 'Part paid', cls: BADGE.part };
  if (inv.status === 'DRAFT') return { label: 'Draft', cls: BADGE.draft };
  return { label: 'Sent', cls: BADGE.sent };
}
